"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputFloatButtons = void 0;
const Journey_1 = require("../../lib/Journey");
exports.InputFloatButtons = Journey_1.Journey.div('j-input-float-buttons');
